<template>
  <v-edit-dialog
    :cancel-text="$t('general.cancel')"
    :save-text="$t('general.update')"
    large
    @save="save"
    @close="internalValue = ''"
    @cancel="internalValue = ''"
  >
    <!-- Cell content -->
    <v-chip
      v-if="hasError"
      color="error"
      class="font-weight-medium"
      small
      link
      v-text="value || value === 0 ? value : $t('general.empty')"
    />
    <span v-else v-text="value" />

    <!-- Input dialog content -->
    <template v-slot:input>
      <v-text-field
        v-model="internalValue"
        :placeholder="placeholder"
        :rules="rules"
        :type="type"
        single-line
        autofocus
      />
    </template>
  </v-edit-dialog>
</template>

<script>
export default {
  name: 'AgDataTableEditDialog',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'number',
    },
    rules: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    internalValue: null,
  }),
  computed: {
    hasError () {
      return this.rules.map(rule => rule(this.value))
        .some(error => error !== true)
    },
    placeholder () {
      return this.value || this.value === 0
        ? `${this.value}`
        : ''
    },
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.internalValue = ''
      },
    },
  },
  methods: {
    save () {
      if (this.internalValue || this.internalValue === 0) {
        const value = this.type === 'number'
          ? +this.internalValue
          : this.internalValue
        this.$emit('input', value)
      }
    },
  },
}
</script>
